var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomsParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.92663 7.03064C9.92663 7.84064 9.26725 8.50003 8.45724 8.50003H6.98785V5.56125H8.45724C9.26725 5.56125 9.92663 6.22063 9.92663 7.03064ZM14.3348 4.09186V12.9082C14.3348 14.2582 13.2358 15.3572 11.8858 15.3572H4.04908C2.69907 15.3572 1.6001 14.2582 1.6001 12.9082V4.09186C1.6001 2.74186 2.69907 1.64288 4.04908 1.64288H11.8858C13.2358 1.64288 14.3348 2.74186 14.3348 4.09186ZM10.9062 7.03064C10.9062 5.68064 9.80724 4.58166 8.45724 4.58166H6.00826V12.4184H6.98785V9.47962H8.45724C9.80724 9.47962 10.9062 8.38064 10.9062 7.03064Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomsParking);
export default __webpack_public_path__ + "static/media/roomsParking.2e4fcaae9978cc902a74851628debbc4.svg";
export { ForwardRef as ReactComponent };